"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReceiveHitStyles = void 0;
exports.createReceiveHitLayer = createReceiveHitLayer;
const react_jss_1 = require("react-jss");
const ATTACK_DURATION_MS = 200;
const HIT_ROTATION_MULTIPLIER_DEG = 1;
exports.useReceiveHitStyles = (0, react_jss_1.createUseStyles)({
    "@keyframes piece-receive-hit-anim": {
        "0%": {
            transform: "rotate(0deg)",
        },
        "25%": {
            transform: `rotate(calc(${HIT_ROTATION_MULTIPLIER_DEG}deg * var(--hitPower) * -1))`,
        },
        "75%": {
            transform: `rotate(calc(${HIT_ROTATION_MULTIPLIER_DEG}deg * var(--hitPower)))`,
        },
        "100%": {
            transform: "rotate(0deg)",
        },
    },
    "receiveHit": {
        animationName: "$piece-receive-hit-anim",
        animationDuration: `${ATTACK_DURATION_MS}ms`,
    },
});
function createReceiveHitLayer(event, className) {
    return {
        name: "receiveHit",
        className,
        cssVariables: {
            hitPower: event.damage,
        },
    };
}
